module.exports = __webpack_public_path__ + "static/media/history_12.933f5f7e.jpg";